import { createSignal, Show } from "solid-js";
import { giveItemsWorth, removeItemsFromInventory, SelectItems } from "~/js/items";
import { pageBgNotification } from "~/js/notifications";
import { addStat } from "~/js/stats";
import { createPage } from "~/js/utils";
import { global, goToPreviousPage } from "~/script";
import type { Item } from "~/types";
import { user } from "~/userStore";

function CoinflipPage() {
	console.log("Coinflip page loaded");
	const [status, setStatus] = createSignal("Choose.");
	const [coinRotation, setCoinRotation] = createSignal("rotateY(0deg)");
	const [coinTransition, setCoinTransition] = createSignal("0s");
	const [showCoin, setShowCoin] = createSignal(false);
	const [showButtons, setShowButtons] = createSignal(false);
	const [selectedItems, setSelectedItems] = createSignal<Item[]>([]);
	const [totalBetValue, setTotalBetValue] = createSignal(0);

	function handleFlip(chosenSide: 0 | 1) {
		global.noSpoilers = true;
		const isWin = Math.round(Math.random()) === chosenSide;
		const items = selectedItems();
		const betValue = totalBetValue();

		addStat("total_bets", 1);
		addStat("total_coinflips", 1);

		if (isWin) {
			if (betValue > 10000) addStat("total_coinflips_won_bet100", 1);
			if (betValue > 100000) addStat("total_coinflips_won_bet1000", 1);
			if (betValue > 1000000) addStat("total_coinflips_won_bet10000", 1);
			addStat("total_bets_won", 1);
			addStat("total_coinflips_won", 1);
		} else {
			if (betValue > 10000) addStat("total_coinflips_lost_bet100", 1);
			if (betValue > 100000) addStat("total_coinflips_lost_bet1000", 1);
			if (betValue > 1000000) addStat("total_coinflips_lost_bet10000", 1);
			addStat("total_bets_lost", 1);
			addStat("total_coinflips_lost", 1);
			removeItemsFromInventory(
				items.map((item) => {
					addStat("total_coinflips_losses", item.price);
					return item.name;
				}),
			);
		}

		setShowButtons(false);
		setShowCoin(true);

		setTimeout(() => {
			setCoinTransition("4s");
			setCoinRotation(`rotateY(${180 * Math.ceil(8 + (isWin ? chosenSide : chosenSide + 1))}deg)`);

			setTimeout(() => {
				setStatus(isWin ? "You Won!" : "You lost!");
				if (isWin) {
					pageBgNotification({
						message: "You won the coinflip, your winnings will show up shortly!",
					});
				} else {
					pageBgNotification({
						message: "You lost the coinflip!",
					});
				}

				setTimeout(() => {
					if (isWin) giveItemsWorth(betValue);
					global.noSpoilers = false;
				}, 1500);
			}, 4200);
		}, 100);
	}

	return (
		<>
			<div classList={{ hide: status() === "Choose." }} id="coinflip-status">
				{status()}
			</div>
			<div classList={{ hide: !showButtons() }} id="coinflip-ct" onClick={() => handleFlip(0)} style={{ cursor: "pointer" }} />
			<div classList={{ hide: !showButtons() }} id="coinflip-t" onClick={() => handleFlip(1)} style={{ cursor: "pointer" }} />
			<div class="coinflip-perspective">
				<div
					classList={{ hide: !showCoin() }}
					id="coinflip-coin"
					style={{
						transform: coinRotation(),
						transition: coinTransition(),
					}}
				>
					<div class="coinflip-face-ct" />
					<div class="coinflip-face-t" />
				</div>
			</div>

			<Show when={!showCoin() && !showButtons()}>
				<SelectItems
					cancel={goToPreviousPage}
					maxBet={user.upgrades.maxbet}
					minBet={250}
					onselect={(items) => {
						if (items === false) return;
						const totalValue = items.reduce((acc, item) => acc + item.price, 0);
						setSelectedItems(items);
						setTotalBetValue(totalValue);
						setStatus("Choose.");
						setCoinRotation("rotateY(0deg)");
						setCoinTransition("0s");
						setShowCoin(false);
						setShowButtons(true);
					}}
				/>
			</Show>
		</>
	);
}

createPage(() => <CoinflipPage />, "coinflip");
